module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ge-Ha-Ic-Jb.3ee87b9a.png";